import axios from "axios";

const API = process.env.REACT_APP_API_URL || "https://vartasocial.com";

const api = axios.create({
  baseURL: API,
  timeout: 20000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;